import React from 'react';
import {withRouter} from 'react-router';

let Topnav = (props) => {
  let tabs = Object.keys(props.tab);
  let match = props.match.params.id;
  let tabsel;
  let changeTablero = (id) => {
    id = id.target.value;
    props.history.push(`/home/show/${id}`);
  }
  let selected = tabs.find((key) => {
    let tabsel = props.tab[key];
    return tabsel[0].id === match
  });
  selected = props.tab[selected];
  if (selected) {
    tabsel = selected[0];
  }
  return (
    <div className="topnav">
      <select defaultValue={match} onChange={changeTablero}>
        {
          tabs.map((key) => {
            let tab = props.tab;
            if (match === tab[key][0].id) {
              return (
                <option 
                  key={key}
                  selected
                  value={tab[key][0].id}
                  style={{backgroundColor: "#4454BB"}}>
                  {tab[key][0].name}</option>
              )
            } else {
              return (
                <option 
                  key={key}
                  value={tab[key][0].id}
                  style={{backgroundColor: "#4454BB"}}>
                  {tab[key][0].name}</option>
              )
            }
          })
        }
      </select>
      <div className="tabname">{tabsel ? tabsel.fullname : null}</div>
    </div>
  )
}

export default withRouter(Topnav);


// WEBPACK FOOTER //
// ./src/Containers/Nav/Topnav.js